import SimpleErrorTrackerService from '../services/simple-error-tracker-service'
import Logger from '../services/logger'
import RouterService from '../services/router-service'

export const logger = new Logger()
export const errorTracker = new SimpleErrorTrackerService(logger)
export const router = new RouterService()
